import { Dispatch, SetStateAction } from 'react';
import { AnimeCool, AnimeInfo, AnimeInfos } from './type';
import titleInfos from './title.json';

interface Obj {
	[prop: string]: string;
}

const url = 'https://api.moemoe.tokyo/anime/v1/master';

export const fetchInitData = async (
	setPullDownlist: Dispatch<SetStateAction<AnimeCool[]>>,
	setAnimeInfoList: Dispatch<SetStateAction<AnimeInfos[]>>,
	setPullDown: Dispatch<SetStateAction<string>>
) => {
	// 1. APIを呼び出して、コンテキストを更新
	const animecools = await getInitPullDownData(setPullDownlist);

	setPullDown(animecools.length.toString());

	// 2. パラメータの作成(※パラメータなし)
	const animecool = animecools[0];

	if (!animecool) {
		return;
	}

	getAnimeInfoListData(setAnimeInfoList, animecool);
};

const getInitPullDownData = async (setPullDownlist: Dispatch<SetStateAction<AnimeCool[]>>) => {
	const animecools: Array<AnimeCool> = [];

	try {
		await fetch(`${url}/cours`)
			.then((res) => res.json())
			.then((data) => {
				Object.keys(data)
					.reverse()
					.forEach(function (key) {
						console.log(data[key]);
						const animecool: AnimeCool = data[key];
						animecools.push(animecool);
					});
				// dispatch(setActressInfo({ actress: records }));
				console.log('animecools', animecools);
				setPullDownlist(animecools);
			});
	} catch (e) {
		console.log('error', e);
	}

	return animecools;
};

export const getAnimeInfoListData = async (
	setAnimeInfoList: Dispatch<SetStateAction<AnimeInfos[]>>,
	animecool: AnimeCool
) => {
	// const query = new URLSearchParams(params);

	try {
		await fetch(`${url}/${animecool.year}/${animecool.cours}`)
			.then((res) => res.json())
			.then((data) => {
				console.log('animeInfo', data);

				const animeInfos: Array<AnimeInfos> = data.map((item: AnimeInfo) => {
					const record = titleInfos.titleInfos.find((titleInfo) => titleInfo.title.match(item.title_short1));
					const amazon_info = { amazon_img_src: record?.amazon_img_src, amazon_url: record?.amazon_url };

					return { ...item, ...amazon_info };
				});
				setAnimeInfoList(animeInfos);
			});
	} catch (e) {
		console.log('error', e);
	}
};
